export enum PurchaseRequisitionSorting {
    CREATED = 'CREATED',
}
